import { useRouter } from 'next/router';
import { Service, ServiceServiceDynamicDynamicZone, Technology } from '../../../types/schema';
import AllServicesPageTemplate from './template';
import { useLocaleContext } from '../../../providers/localeProvider';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { additionalLinkTags, breadcrumbTitle, SEO } from '../../../utils/SEO';

export type AllServicesPageComponentProps = {
  metaImage?: string;
  metaTitle?: string;
  metaDescription?: string;
  hideAppMastersTitle?: boolean;
  service: Service;
  serviceDynamic: ServiceServiceDynamicDynamicZone[];
  technologies?: Technology[];
};

const AllServicesPageComponent: React.FC<AllServicesPageComponentProps> = (props) => {
  const { locale } = useLocaleContext();
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000/';
  const router = useRouter();
  const isEn = router.locale === 'en';

  const itemListElements = [
    {
      position: 1,
      name: 'App Masters',
      item: `${siteUrl}${router.locale}`,
    },
    {
      position: 2,
      name: breadcrumbTitle(
        props.metaTitle || (isEn ? 'Services' : 'Serviços'),
        isEn,
        props.hideAppMastersTitle,
      ),
      item: `${siteUrl}${router.locale}/${isEn ? 'services' : 'servicos'}`,
    },
  ];

  return (
    <>
      <NextSeo
        {...SEO({
          pathname: router.asPath,
          locale: router.locale as string,
          title: props.metaTitle as string,
          defaultTitle: {
            enTitle: 'Services',
            ptTitle: 'Serviços',
          },
          description: props.metaDescription || (props.service.description as string),
          image: props.metaImage as string,
          hideAppMastersTitle: props.hideAppMastersTitle as boolean,
        })}
        additionalLinkTags={additionalLinkTags(['servicos', 'services'])}
      />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      <AllServicesPageTemplate {...props} locale={locale} />
    </>
  );
};

export default AllServicesPageComponent;
